module.exports = __webpack_public_path__ + "media/images/icons/download-arrow-029dca006c8a7513aa3d81c608774be7.svg";